module.exports = __webpack_public_path__ + "img/date.43878da9.svg";